import { connect } from 'react-redux';
import Modal from 'comp/modals/add_account';
import { cache } from 'utils';

const mapToProps = state => ({
  provide_status: state.fetch.user_add_account || cache.empty_obj,
  verify_status: state.fetch.user_verify_add_account || cache.empty_obj
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/AddAccount.js